export default "__VITE_ASSET__DkPA$3aP__"